import React from 'react';
import { FaUserPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import S from '../../../../../../sass/buttons/modern-btn.module.scss';
import * as PropTypes from 'prop-types';

const BtnGroupInvite = ({ disabled, handleInvite }) => {
  const { t } = useTranslation();

  return (
    <button className={S.modernBtn} onClick={handleInvite} disabled={disabled}>
      <FaUserPlus /> {t('groupsPage.actions.invite')}
    </button>
  );
};

BtnGroupInvite.displayName = 'BtnGroupInvite';

BtnGroupInvite.propTypes = {
  disabled: PropTypes.bool,
  handleInvite: PropTypes.func,
};

export { BtnGroupInvite };
